import { Component, OnInit,ViewChild,ViewContainerRef, Output, EventEmitter } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { MySharedService } from '../App/shared.service';
import { Router} from '@angular/router';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';

declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;

@Component({
    templateUrl: './AppViews/ReviewEmployee/ReviewEmployeePrint.html'
})

export class ReviewEmployeePrintComponent implements OnInit {
    userDetail: any;
    public constants: Constants;
 
    public ReviewEmployeePrint:any = null;
    public StageId:any = null;
    
    public showLoader = false;
    public safeDocUrl:SafeUrl;
    public DocURL:any;


    constructor(private _httpService: HTTPService, private _sharedService: MySharedService,private _route: Router,private sanitizer: DomSanitizer) {
         this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        this.ReviewEmployeePrint = JSON.parse(localStorage.getItem("ReviewEmployeePrintId"));
        this.StageId = JSON.parse(localStorage.getItem("ReviewEmployeePrintStageId"));
        
    }

    ngOnInit() {
        if(this.StageId==4)
      this.printPDf();
      if(this.StageId==3)
      this.printinputPDf();
      if(this.StageId==2)
        this.printKRAPDf();
        
      if(this.DocURL == null || this.DocURL == ""){
      this.DocURL = "../App/images/nocontent.png";
       var safeUrl =  this.sanitizer.bypassSecurityTrustResourceUrl(JSON.parse(JSON.stringify(this.DocURL)));

       this.safeDocUrl =  safeUrl;
   }
    }

   

   
    public printPDf(){
 this.showLoader = true;

 this._httpService.ajaxPost('ReviewEmployee/GetPrintReviewEmployee', { "TemplateId":this.ReviewEmployeePrint}).subscribe(
            data => {
         
        //         var item = {
        //     DocName: data["DocName"][0],
        //     FolderPath: data["DocName"][1]
        // };

        //item.FolderPath = this.printFeedBackModel.FileDocPath;

     //   this.jobDocChild.showDoc(JSON.parse(JSON.stringify(item)));
     //   this.showDocPopupSurvey()
     this.DocURL=data["DocName"][1];
       var safeUrl =  this.sanitizer.bypassSecurityTrustResourceUrl(JSON.parse(JSON.stringify(this.DocURL)));

       this.safeDocUrl =  safeUrl;
                this.showLoader = false;
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }
     
    public printinputPDf(){
 this.showLoader = true;

 this._httpService.ajaxPost('ReviewEmployee/GetPrintinputPDf', { "TemplateId":this.ReviewEmployeePrint}).subscribe(
            data => {
         
        //         var item = {
        //     DocName: data["DocName"][0],
        //     FolderPath: data["DocName"][1]
        // };

        //item.FolderPath = this.printFeedBackModel.FileDocPath;

     //   this.jobDocChild.showDoc(JSON.parse(JSON.stringify(item)));
     //   this.showDocPopupSurvey()
     console.log("data", data);
     this.DocURL=data["DocName"][1];
       var safeUrl =  this.sanitizer.bypassSecurityTrustResourceUrl(JSON.parse(JSON.stringify(this.DocURL)));

       this.safeDocUrl =  safeUrl;
                this.showLoader = false;
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }
     
    public printKRAPDf(){
 this.showLoader = true;

 this._httpService.ajaxPost('ReviewEmployee/GetprintKRAPDf', { "TemplateId":this.ReviewEmployeePrint}).subscribe(
            data => {
         
        //         var item = {
        //     DocName: data["DocName"][0],
        //     FolderPath: data["DocName"][1]
        // };

        //item.FolderPath = this.printFeedBackModel.FileDocPath;

     //   this.jobDocChild.showDoc(JSON.parse(JSON.stringify(item)));
     //   this.showDocPopupSurvey()
     this.DocURL=data["DocName"][1];
       var safeUrl =  this.sanitizer.bypassSecurityTrustResourceUrl(JSON.parse(JSON.stringify(this.DocURL)));

       this.safeDocUrl =  safeUrl;
                this.showLoader = false;
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }
        
    }



/** WEBPACK FOOTER **
 ** ./TypeScripts/ReviewEmployee/ReviewEmployeePrint.component.ts
 **/